export const defectTypeSchema: any = {
  id: "",
  defectType: [],
  createdBy: "",
  locationId: "",
  organizationId: "",
  productId: "",
};
